import { type ItemProps, Lightbox } from "@msuite/ui/lightbox";
import { getFileAnnotations, saveFileAnnotations } from "@/api/files";
import { useAnnotatedLightbox } from "./annotated-lightbox-context";

/**
 * One lightbox image wired to the file annotations.
 *
 * The annotator opens editable. Annotating follows the parent a file hangs on, and a lightbox item
 * knows only the file — the project gallery collects pictures from tickets, notes and the project
 * itself into one grid — so there is no parent to ask, and the server answers the save.
 */
export function AnnotatedLightboxItem(props: ItemProps) {
	/** Context */
	const { annotatedFileIds } = useAnnotatedLightbox();

	/** Render */
	return (
		<Lightbox.Item
			{...props}
			getAnnotations={(fileId) => getFileAnnotations(fileId)}
			onSaveAnnotations={saveFileAnnotations}
			hasAnnotations={annotatedFileIds.has(props.id)}
		/>
	);
}
